import { gql } from '@apollo/client';

/**
 * GraphQL mutation to update a strike policy.
 * Strike policies use strikeThreshold (point accumulation) instead of labels.
 */
export const UPDATE_STRIKE_POLICY = gql`
  mutation UpdateStrikePolicy($communityId: ID!, $policyId: ID!, $input: UpdatePolicyInput!) {
    updatePolicy(communityId: $communityId, policyId: $policyId, input: $input) {
      id
      communityId
      name
      description
      isEnabled
      workflowType
      strikeThreshold
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
